"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var patch_exports = {};
__export(patch_exports, {
  run: () => run
});
module.exports = __toCommonJS(patch_exports);
var import_loadConfig = require("../vite/loadConfig");
function isMissingViteConfigError(error) {
  return error instanceof Error && error.message.startsWith("No config config in ") && error.message.endsWith(" Is this the correct directory?");
}
async function loadUserOptions() {
  try {
    return await (0, import_loadConfig.loadUserOneOptions)("build");
  } catch (error) {
    if (isMissingViteConfigError(error)) {
      return void 0;
    }
    throw error;
  }
}
async function run(args) {
  process.env.IS_VXRN_CLI = "true";
  var { patch } = await import("vxrn");
  var options = await loadUserOptions();
  var patches = options === null || options === void 0 ? void 0 : options.oneOptions.patches;
  if (process.env.DEBUG) {
    console.info("User patches:", Object.keys(patches || {}));
  }
  await patch({
    root: process.cwd(),
    deps: patches,
    force: args.force
  });
}
//# sourceMappingURL=patch.js.map
